import React, { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { useNavigate } from 'react-router-dom';
import logoArrows from '../images/logo_arrows.svg'; // Adjust the path as needed
import { ArrowLeft } from 'lucide-react';

const TermsOfService = () => {
  const [isNative, setIsNative] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setIsNative(Capacitor.isNativePlatform());
  }, []);

  const handleGoBack = () => {
    navigate(-1); // go back to previous page
  };

  return (
    <div
      style={{
        fontFamily: 'Arial, sans-serif',
        padding: '20px',
        maxWidth: '800px',
        margin: '0 auto',
        position: 'relative',
      }}
    >
      {/* Back Button for Native Platforms */}
      {isNative && (
        <div
          style={{
            position: 'absolute',
            top: 20,
            left: 20,
            zIndex: 1000,
            cursor: 'pointer',
          }}
          onClick={handleGoBack}
          title="Go Back"
        >
          <ArrowLeft size={28} />
        </div>
      )}

      {/* Logo at the top center */}
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <img src={logoArrows} alt="EasySubs Logo" style={{ maxWidth: '200px', height: 'auto' }} />
      </div>

      <h1>Terms of Service</h1>
      <p><strong>Effective Date:</strong> February 17, 2026</p>
      <p><strong>Last Updated:</strong> February 19, 2026</p>
      <p><strong>Company Name:</strong> Easysubs</p>
      <p><strong>Contact Email:</strong> info@easysubs.it</p>

      {/* Note about English version */}
      <p style={{
        textAlign: 'center',
        fontSize: '14px',
        fontStyle: 'italic',
        marginBottom: '30px',
        color: '#666'
      }}>
        The English version of this policy follows below / La versione inglese di questa policy segue sotto
      </p>

      {/* Italian Version */}
      <div style={{ marginBottom: '40px' }}>
        <h2 style={{ borderBottom: '2px solid #333', paddingBottom: '10px' }}>
          🇮🇹 Versione Italiana
        </h2>

        <h2>1. ACCETTAZIONE DEI TERMINI</h2>
        <p>Accedendo e utilizzando i servizi di EasySubs, sia tramite il nostro sito web che tramite l'applicazione mobile, accetti di essere vincolato da queste Condizioni di Servizio. Se non accetti questi termini, non dovresti utilizzare i nostri servizi.</p>
        <p>Ai fini delle presenti Condizioni di Servizio, quando vengono utilizzati i termini "Noi", "Ci", "Nostro" o "EasySubs" o "Easysubs", essi si riferiscono a Easysubs come entità che fornisce i servizi.</p>

        <h2>2. DESCRIZIONE DEI SERVIZI</h2>
        <p>EasySubs fornisce un servizio gratuito di reportistica dinamica per monitorare e gestire le spese di abbonamento. Inoltre, offriamo un servizio premium di gestione degli abbonamenti, in cui gestiamo gli abbonamenti per conto degli utenti a fronte di un costo.</p>
        <p>Inoltre, aiutiamo gli utenti a trovare tariffe migliori collegandoli a offerte specifiche per abbonati, aiutandoli a ottimizzare la spesa su servizi ricorrenti.</p>

        <h2>3. RESPONSABILITÀ DELL'UTENTE</h2>
        <ul>
          <li>Gli utenti devono fornire dati di abbonamento accurati e aggiornati per garantire il corretto funzionamento dei nostri servizi.</li>
          <li>Gli utenti devono inoltre selezionare il proprio Paese di servizio, necessario per visualizzare piani di abbonamento accurati, prezzi regionali e conversioni di valuta.</li>
          <li>Eventuali inesattezze o informazioni mancanti potrebbero comportare l'impossibilità di fornire i servizi promessi, e non saremo responsabili per eventuali problemi derivanti da dati errati.</li>
        </ul>

        <h2>4. SERVIZIO PREMIUM & TERMINI DI PAGAMENTO</h2>
        <ul>
          <li>EasySubs offre servizi premium per gestire attivamente gli abbonamenti per conto degli utenti.</li>
          <li>I termini di pagamento, i prezzi e i cicli di fatturazione saranno chiaramente indicati al momento della sottoscrizione.</li>
          <li>L'eventuale mancata elaborazione del pagamento può comportare la sospensione o la cessazione dei servizi premium.</li>
        </ul>

        <h2>5. PRIVACY DEI DATI & CONSERVAZIONE</h2>
        <ul>
          <li>EasySubs si impegna a proteggere la privacy dei dati degli utenti. Potremmo conservare i dati degli utenti o trasferire i dati al di fuori dell'Unione Europea (UE).</li>
          <li>Utilizzando i nostri servizi, riconosci e acconsenti a tale modalità di conservazione dei dati.</li>
          <li>Dati statistici aggregati e completamente anonimizzati (come categorie di abbonamento e fasce di spesa per regione) possono essere utilizzati per finalità di reportistica analitica e commerciale. Nessuna informazione personalmente identificabile o dato a livello di singolo utente viene condiviso con terze parti.</li>
        </ul>

        <h2>6. SERVIZI DI TERZE PARTI & REINDIRIZZAMENTO</h2>
        <ul>
          <li>EasySubs può fornire link o reindirizzare gli utenti a piattaforme di terze parti per servizi o offerte aggiuntive.</li>
          <li>Non garantiamo la disponibilità, accuratezza o performance di alcun servizio di terze parti.</li>
          <li>EasySubs non è responsabile per eventuali guasti, problemi o danni subiti dagli utenti che tentano di sottoscrivere servizi tramite piattaforme di terze parti, anche se reindirizzati dalla nostra piattaforma.</li>
          <li>Alcuni brand, piattaforme o fornitori mostrati su EasySubs potrebbero non essere partner ufficiali di EasySubs.</li>
        </ul>

        <h2>7. LIMITAZIONE DI RESPONSABILITÀ</h2>
        <ul>
          <li>EasySubs non è responsabile per fallimenti nella cancellazione degli abbonamenti, pagamenti mancati o interruzioni del servizio dovuti a fattori esterni.</li>
          <li>Forniamo raccomandazioni e tracciamento automatizzato basati sui dati disponibili, ma non garantiamo un'accuratezza assoluta.</li>
          <li>Gli utenti sono in ultima istanza responsabili della gestione dei propri impegni finanziari e della verifica delle modifiche agli abbonamenti.</li>
          <li>Nella misura massima consentita dalla legge, EasySubs non sarà responsabile per danni indiretti, incidentali o consequenziali legati all'uso dei nostri servizi.</li>
        </ul>

        <h2>8. DISPONIBILITÀ DEI SERVIZI</h2>
        <ul>
          <li>I servizi di EasySubs sono forniti tramite applicazioni web e mobile.</li>
          <li>La nostra piattaforma è disponibile per tutti gli utenti di età pari o superiore a 18 anni.</li>
          <li>Ci riserviamo il diritto di modificare o interrompere qualsiasi servizio in qualsiasi momento, con o senza preavviso.</li>
        </ul>

        <h2>9. MODIFICHE AI TERMINI DI SERVIZIO</h2>
        <ul>
          <li>EasySubs può aggiornare periodicamente queste Condizioni di Servizio.</li>
          <li>Gli utenti saranno informati di modifiche significative tramite email o notifiche in-app.</li>
          <li>L'uso continuato dei servizi dopo le modifiche costituisce accettazione dei termini aggiornati.</li>
        </ul>

        <h2>10. LEGGE APPLICABILE</h2>
        <p>Le presenti Condizioni di Servizio sono regolate dalle leggi italiane. Eventuali controversie derivanti da questi termini saranno risolte sotto la giurisdizione di Milano, Italia.</p>

        <h2>11. CONTATTI</h2>
        <p>Per qualsiasi domanda relativa alle presenti Condizioni di Servizio, contattaci a <a href="mailto:info@easysubs.it">info@easysubs.it</a>.</p>

        <h2>12. CONFORMITÀ GDPR</h2>
        <ul>
          <li>EasySubs si impegna a rispettare il Regolamento Generale sulla Protezione dei Dati (GDPR). Ciò include:
            <ul>
              <li><strong>Diritti dell'utente:</strong> gli utenti hanno il diritto di accedere, rettificare, cancellare o limitare il trattamento dei propri dati personali. Le richieste possono essere inviate contattando info@easysubs.it.</li>
              <li><strong>Misure di protezione dei dati:</strong> implementiamo misure di sicurezza adeguate per proteggere i dati degli utenti.</li>
              <li><strong>Conservazione dei dati:</strong> conserviamo i dati personali solo per il tempo necessario a fornire i nostri servizi e rispettare gli obblighi legali.</li>
              <li><strong>Consenso dell'utente:</strong> utilizzando EasySubs, gli utenti acconsentono esplicitamente alla raccolta e al trattamento dei loro dati come descritto in queste Condizioni di Servizio e nella nostra Privacy Policy.</li>
              <li><strong>Trasferimenti internazionali di dati:</strong> i nostri dati possono essere conservati al di fuori dell'UE, gli utenti riconoscono e acconsentono a potenziali trasferimenti internazionali in conformità al GDPR.</li>
            </ul>
          </li>
        </ul>

        <p>Utilizzando EasySubs, riconosci di aver letto, compreso e accettato queste Condizioni di Servizio.</p>
      </div>

      {/* English Version */}
      <div style={{ borderTop: '2px solid #333', paddingTop: '20px' }}>
        <h2 style={{ borderBottom: '2px solid #333', paddingBottom: '10px' }}>
          🇬🇧 English Version
        </h2>

        <h2>1. ACCEPTANCE OF TERMS</h2>
        <p>By accessing and using EasySubs' services, whether through our website or mobile application, you agree to be bound by these Terms of Service. If you do not agree to these terms, you should not use our services.</p>
        <p>For the purpose of these Terms of Service, when the terms "We," "Us," "Our," or "EasySubs" or "Easysubs" are used, they refer to Easysubs as the entity providing the services.</p>

        <h2>2. DESCRIPTION OF SERVICES</h2>
        <p>EasySubs provides a free dynamic reporting service for tracking and managing subscription expenses. Additionally, we offer a premium subscription management service, where we manage subscriptions on behalf of users for a fee.</p>
        <p>Furthermore, we assist users in finding better fares by connecting them to specific subscriber offers, helping them optimize their spending on recurring services.</p>

        <h2>3. USER RESPONSIBILITIES</h2>
        <ul>
          <li>Users must provide accurate and up-to-date subscription data to ensure the correct operation of our services.</li>
          <li>Users must also select their country of service, which is necessary to display accurate subscription plans, regional pricing, and currency conversions.</li>
          <li>Any inaccuracies or missing information may result in our inability to deliver the promised services, and we will not be liable for any issues arising from incorrect data.</li>
        </ul>

        <h2>4. PREMIUM SERVICE & PAYMENT TERMS</h2>
        <ul>
          <li>EasySubs offers premium services for actively managing subscriptions on behalf of users.</li>
          <li>Payment terms, pricing, and billing cycles will be clearly stated at the point of subscription.</li>
          <li>Failure to process payment may result in the suspension or termination of premium services.</li>
        </ul>

        <h2>5. DATA PRIVACY & STORAGE</h2>
        <ul>
          <li>EasySubs is committed to protecting user data privacy. We may store user data or transfer data outside the European Union (EU).</li>
          <li>By using our services, you acknowledge and consent to this data storage arrangement.</li>
          <li>Aggregated and fully anonymized statistical data (such as subscription categories and spending ranges by region) may be used for analytical and commercial reporting purposes. No personally identifiable information or user-level data is shared with third parties.</li>
        </ul>

        <h2>6. THIRD-PARTY SERVICES & REDIRECTION</h2>
        <ul>
          <li>EasySubs may provide links or redirect users to third-party platforms for additional services or offers.</li>
          <li>We do not guarantee the availability, accuracy, or performance of any third-party services.</li>
          <li>EasySubs is not liable for any failure, issue, or damage incurred by users attempting to subscribe to services through third-party platforms, even if redirected from our platform.</li>
          <li>Some brands, platforms, or providers displayed on EasySubs may not be official partners of EasySubs.</li>
        </ul>

        <h2>7. LIMITATION OF LIABILITY</h2>
        <ul>
          <li>EasySubs is not responsible for subscription cancellation failures, missed payments, or service interruptions due to external factors.</li>
          <li>We provide recommendations and automated tracking based on available data, but we do not guarantee absolute accuracy.</li>
          <li>Users are ultimately responsible for managing their own financial commitments and verifying subscription changes.</li>
          <li>To the fullest extent permitted by law, EasySubs shall not be liable for any indirect, incidental, or consequential damages related to the use of our services.</li>
        </ul>

        <h2>8. AVAILABILITY OF SERVICES</h2>
        <ul>
          <li>EasySubs' services are provided through both web and mobile applications.</li>
          <li>Our platform is available to all users aged 18 and older.</li>
          <li>We reserve the right to modify or discontinue any service at any time, with or without notice.</li>
        </ul>

        <h2>9. CHANGES TO TERMS OF SERVICE</h2>
        <ul>
          <li>EasySubs may update these Terms of Service periodically.</li>
          <li>Users will be notified of significant changes through email or in-app notifications.</li>
          <li>Continued use of the services after changes are made constitutes acceptance of the updated terms.</li>
        </ul>

        <h2>10. GOVERNING LAW</h2>
        <p>These Terms of Service are governed by the laws of Italy. Any disputes arising from these terms shall be resolved under the jurisdiction of Milan, Italy.</p>

        <h2>11. CONTACT INFORMATION</h2>
        <p>For any questions regarding these Terms of Service, please contact us at <a href="mailto:info@easysubs.it">info@easysubs.it</a>.</p>

        <h2>12. GDPR COMPLIANCE</h2>
        <ul>
          <li>EasySubs is committed to complying with the General Data Protection Regulation (GDPR). This includes:
            <ul>
              <li><strong>User Rights:</strong> Users have the right to access, rectify, delete, or restrict the processing of their personal data. Requests can be made by contacting info@easysubs.it.</li>
              <li><strong>Data Protection Measures:</strong> We implement appropriate security measures to safeguard user data.</li>
              <li><strong>Data Retention:</strong> We retain personal data only for as long as necessary to provide our services and comply with legal obligations.</li>
              <li><strong>User Consent:</strong> By using EasySubs, users explicitly consent to the collection and processing of their data as described in these Terms of Service and our Privacy Policy.</li>
              <li><strong>International Data Transfers:</strong> our data may be stored outside the EU, users acknowledge and consent to potential cross-border data transfers in accordance with GDPR regulations.</li>
            </ul>
          </li>
        </ul>

        <p>By using EasySubs, you acknowledge that you have read, understood, and agreed to these Terms of Service.</p>
      </div>
    </div>
  );
};

export default TermsOfService;